import { Dispatch } from 'redux';

import { apiFetchGradProgram } from 'api/gradSchools/apiGradSchools';
import { ApiGradProgram } from 'api/gradSchools/types/ApiGradProgram';
import { ApiUnpublishedGradProgram } from 'api/gradSchools/types/ApiUnpublishedGradProgram';
import { setError } from 'modules/main/store/ducks/error';

// Types

export type MainStoreGradSchoolsGradProgramsState = {
  byId: Record<
    string,
    {
      gradProgram: ApiGradProgram | ApiUnpublishedGradProgram;
      isFetching?: boolean;
    }
  >;
};

type FetchGradProgramRequestAction = {
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST';
  programId: string;
};

type FetchGradProgramSuccessAction = {
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS';
  program: ApiGradProgram;
};

export type MainStoreGradSchoolsGradProgramsAction =
  | FetchGradProgramRequestAction
  | FetchGradProgramSuccessAction;

// Reducer

export function gradProgramsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreGradSchoolsGradProgramsState = {
    byId: {},
  },
  action: MainStoreGradSchoolsGradProgramsAction,
) {
  switch (action.type) {
    case 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.programId]: {
            ...state.byId[action.programId],
            isFetching: true,
          },
        },
      };

    case 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.program.id]: {
            gradProgram: action.program,
            isFetching: false,
          },
        },
      };

    default:
      return state;
  }
}

// Actions

const fetchGradProgramRequest = (
  programId: string,
): FetchGradProgramRequestAction => ({
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_REQUEST',
  programId,
});

const fetchGradProgramSuccess = (
  program: ApiGradProgram,
): FetchGradProgramSuccessAction => ({
  type: 'GRAD_SCHOOLS_FETCH_PROGRAM_SUCCESS',
  program,
});

export const fetchGradProgram =
  (programId: string) =>
  (
    dispatch: Dispatch,
    getState: () => {
      gradSchools: { gradPrograms: MainStoreGradSchoolsGradProgramsState };
    },
  ): Promise<ApiGradProgram | Error> =>
    new Promise((resolve, reject) => {
      const {
        gradSchools: { gradPrograms },
      } = getState();
      const program = gradPrograms.byId[programId];

      if (!program) {
        dispatch(fetchGradProgramRequest(programId));
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line no-promise-executor-return
        return apiFetchGradProgram(programId)
          .then((fetchedGradProgram) => {
            dispatch(fetchGradProgramSuccess(fetchedGradProgram));
            resolve(fetchedGradProgram);
          })
          .catch((e) => {
            if (e.statusCode !== 404) {
              dispatch(setError(e));
            } else {
              reject(e);
            }
          });
      }
    });

export const updateGradProgram = fetchGradProgramSuccess;
